import styled from "styled-components";

export const JourneysPageStyle = styled.div`

`;
